'use strict';
import angular, { element } from 'angular';
import _, { toArray } from 'lodash';

import adUnitsHtmlUrl from './views/adUnits.list.html';
import adUnitsRecHtmlUrl from './views/recursiveTemplate.html';
import adUnitsModalHtmlUrl from './views/modalView.html';

var app = angular.module('app.adUnitsComponent', []);

app.component('dfpAdUnits', {
    bindings: {
        showActions: '=',
        selectedAdUnits: '=',
        clusterId: '='
    },
    templateUrl: adUnitsHtmlUrl,

    // The controller that handles our component logic
    controller: function (ProductService, $filter, $scope, FormService) {
        var self = this;
        self.adUnitsSearch = "";
        self.adUnitsList = [];
        self.setOfAdUnitsList = [];
        var AD_UNITS_LIMIT = 25;
        self.adUnitsIncluded = [];
        self.adUnitsExcluded = [];
        self.adUnitsIncludedView = [];
        self.adUnitsExcludedView = [];
        self.adUnitsRecHtmlUrl = adUnitsRecHtmlUrl;
        self.adUnitsModalHtmlUrl = adUnitsModalHtmlUrl;
        self.previousAdunitsList = [];
        self.searchAdUnitsList = [];

        self.setChlidDataCreteriaExclude = function (item) {
            if (item.childData && item.childData.length > 0) {
                item.childData.forEach(element => {
                    element.showExclude = false;
                    element.showInclude = false;
                    if (element.childData && element.childData.length > 0) {
                        self.setChlidDataCreteriaExclude(element);
                    }
                });
            }
        };

        self.setChlidDataCreteriaInclude = function (item) {
            if (item.childData && item.childData.length > 0) {
                item.childData.forEach(element => {
                    element.showExclude = true;
                    element.showInclude = false;
                    if (element.childData && element.childData.length > 0 && element.criteria_link != 'excluded') {
                        self.setChlidDataCreteriaInclude(element);
                    }
                });
            }
        };

        self.setChlidDataDefaultCreteria = function (item) {
            if (item.childData && item.childData.length > 0) {
                item.childData.forEach(element => {
                    if(element.criteria_link == 'excluded' && element.childData && element.childData.length > 0){
                        element.showInclude = true;
                        self.setChlidDataCreteriaExclude(element);
                    } else{
                        element.showExclude = true;
                        element.showInclude = true;
                        if (element.childData && element.childData.length > 0) {
                            self.setChlidDataDefaultCreteria(element);
                        }
                    }
                });
            }
        };

        self.removeChildNodesCriteria = function (item) {
            if (item.childData && item.childData.length > 0) {
                _.each(item.childData, function (el) {
                    var selIndex =  _.findIndex(self.selectedAdUnits, { valueId: el.valueId });
                    if (selIndex >= 0) {
                        self.selectedAdUnits.splice(selIndex, 1);
                        var itemIndex;
                        if (el.criteria == 'include') {
                            itemIndex = self.adUnitsIncluded.indexOf(el);
                            self.adUnitsIncluded.splice(itemIndex, 1);
                        }
                        else {
                            itemIndex = self.adUnitsExcluded.indexOf(el);
                            self.adUnitsExcluded.splice(itemIndex, 1);
                        }
                        el.criteria = '';
                        el.criteria_link = 'include';
                    }
                    self.removeChildNodesCriteria(el)
                })
            }

        };

        self.removeIncludedChildNodes = function (item) {
            if (item.childData && item.childData.length > 0) {
                _.each(item.childData, function (el) {
                    if (el.criteria_link == 'included') {
                        var selIndex = self.selectedAdUnits.indexOf(el);
                        if (selIndex >= 0) {
                            self.selectedAdUnits.splice(selIndex, 1);
                            var itemIndex = self.adUnitsIncluded.indexOf(el);
                            self.adUnitsIncluded.splice(itemIndex, 1);
                            el.criteria = '';
                            el.criteria_link = 'include';
                        }
                    }
                    self.removeIncludedChildNodes(el);
                })
            }
        };

        self.changeIncludeExclude = function (item, criteria, from, parent) {
            if (from == 'childLevel') {
                var indexVal = parent.childData.indexOf(item);
                if (indexVal >= 0) {
                    if (criteria == "include") {
                        parent.childData[indexVal].criteria = 'include';
                        parent.childData[indexVal].criteria_link = 'included';
                        self.removeIncludedChildNodes(item);
                        self.setChlidDataCreteriaInclude(item);
                    } else if (criteria == "exclude") {
                        parent.childData[indexVal].criteria = 'exclude';
                        parent.childData[indexVal].criteria_link = 'excluded';
                        self.removeChildNodesCriteria(item);
                        self.setChlidDataCreteriaExclude(item);
                    } else {
                        parent.childData[indexVal].criteria = '';
                        parent.childData[indexVal].criteria_link = 'include';
                    }
                    var selIndex = _.findIndex(self.selectedAdUnits, { valueId: parent.childData[indexVal].valueId });
                    if (selIndex >= 0) {
                        self.selectedAdUnits[selIndex] = parent.childData[indexVal];
                    } else {
                        self.selectedAdUnits.push(parent.childData[indexVal]);
                    }
                    self.adUnitsIncluded = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'include'; });
                    self.adUnitsExcluded = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'exclude'; });
                }
            } else {
                var index = self.adUnitsList.indexOf(item);
                if (index >= 0) {
                    if (criteria == "include") {
                        self.adUnitsList[index].criteria = 'include';
                        self.adUnitsList[index].criteria_link = 'included';
                        self.removeIncludedChildNodes(item);
                        self.setChlidDataCreteriaInclude(item);
                    } else if (criteria == "exclude") {
                        self.adUnitsList[index].criteria = 'exclude';
                        self.adUnitsList[index].criteria_link = 'excluded';
                        self.removeChildNodesCriteria(item);
                        self.setChlidDataCreteriaExclude(item);
                    } else {
                        self.adUnitsList[index].criteria = '';
                        self.adUnitsList[index].criteria_link = 'include';
                    }
                    var selIndex = _.findIndex(self.selectedAdUnits, { valueId: self.adUnitsList[index].valueId });
                    if (selIndex >= 0) {
                        self.selectedAdUnits[selIndex] = self.adUnitsList[index];
                    } else {
                        self.selectedAdUnits.push(self.adUnitsList[index]);
                    }
                    self.adUnitsIncluded = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'include'; });
                    self.adUnitsExcluded = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'exclude'; });
                }
            }
        }

        self.checkingCriteria = function () {
            for (var k = 0; k < self.selectedAdUnits.length; k++) {
                for (var j = 0; j < self.adUnitsList.length; j++) {
                    if (self.selectedAdUnits[k].name == self.adUnitsList[j].name) {
                        if (self.selectedAdUnits[k].criteria == "include") {
                            self.adUnitsList[j].criteria = 'include';
                            self.adUnitsList[j].criteria_link = 'included';
                        } else if (self.selectedAdUnits[k].criteria == "exclude") {
                            self.adUnitsList[j].criteria = 'exclude';
                            self.adUnitsList[j].criteria_link = 'excluded';
                        } else {
                            self.adUnitsList[j].criteria = '';
                            self.adUnitsList[j].criteria_link = 'include';
                        }
                    }
                }
            }
        }

        self.removeAdUnit = function (item) {
            var selIndex = self.selectedAdUnits.indexOf(item);
            if (selIndex >= 0) {
                self.selectedAdUnits.splice(selIndex, 1);
                var itemIndex;
                if (item.criteria == 'include') {
                    itemIndex = self.adUnitsIncluded.indexOf(item);
                    self.adUnitsIncluded.splice(itemIndex, 1);
                }
                else {
                    itemIndex = self.adUnitsExcluded.indexOf(item);
                    self.adUnitsExcluded.splice(itemIndex, 1);
                }
            }
            var index = _.findIndex(self.adUnitsList, { valueId: item.valueId });
            if (index >= 0) {
                self.adUnitsList[index].criteria = '';
                self.adUnitsList[index].criteria_link = 'include';
                if (self.adUnitsList[index].childData && self.adUnitsList[index].childData.length > 0) {
                    var selectedCretiriaList = [];
                    self.applyCriteria(self.adUnitsList[index].childData, item, selectedCretiriaList);
                }
            } else {
                var parentIndex = _.findIndex(self.adUnitsList, { valueId: item.superParentId });
                if(parentIndex >=0){
                    self.resetChildCriteria(self.adUnitsList[parentIndex].childData,item);
                }
                // item.criteria = '';
                // item.criteria_link = 'include';
                if (self.adUnitsList[parentIndex].criteria_link == 'included') {
                    self.setChlidDataCreteriaInclude(item);
                } else if (self.adUnitsList[parentIndex].criteria_link == 'excluded') {
                    self.setChlidDataCreteriaExclude(item);
                } else {
                    var selectedCretiriaList = [];
                    self.applyCriteria(self.adUnitsList[parentIndex].childData, item, selectedCretiriaList);
                }
            }
        }

        self.resetChildCriteria = function(childData,item){
            _.each(childData,function(el,index){
                if(el.valueId == item.valueId){
                    el.criteria = '';
                    el.criteria_link = 'include';
                }
                if(el.childData && el.childData.length > 0){
                    self.resetChildCriteria(el.childData,item);
                }
            })
        }

        self.clearSelectedAdUnits = function () {
            self.selectedAdUnits = [];
            self.adUnitsIncluded = [];
            self.adUnitsExcluded = [];
            _.map(self.adUnitsList, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
                self.clearSelectedChildNodes(item);
                self.setChlidDataDefaultCreteria(item);
            });

        }

        self.clearSelectedChildNodes = function (item) {
            if (item.childData && item.childData.length > 0) {
                _.each(item.childData, function (childItem) {
                    childItem.criteria = '';
                    childItem.criteria_link = 'include';
                    self.clearSelectedChildNodes(childItem);
                })
            }
        }

        /*
        * load ad units on search text
        */
        self.loadSearchUnits = function () {
            if (event.keyCode == 13 && self.adUnitsSearch.length >= 3) {
                var params = {};
                if (isNaN(parseInt(self.adUnitsSearch))) {
                    params = { type: 'dfp_ad_unit', search_criteria: self.adUnitsSearch.replace(/[\s]/g,' '), search_by: 'name', cluster_id: self.clusterId }
                } else {
                    params = { type: 'dfp_ad_unit', search_criteria: parseInt(self.adUnitsSearch), search_by: 'valueId', cluster_id: self.clusterId }
                }
                ProductService.searchAdunitsByInput(params).then(function (success) {
                    if (success.data && success.data.length > 0) {
                        self.searchAdUnitsList = [];
                        _.each(success.data, function (content) {
                            var adUnit = {};
                            adUnit.valueId = content.valueId;
                            adUnit.name = content.name;
                            adUnit.criteria = "";
                            adUnit.criteria_link = "include";
                            adUnit.childData = content.childData ? _.toArray(content.childData) : null;
                            adUnit.hasChildren = content.hasChildren;
                            self.searchAdUnitsList.push(adUnit);
                        })
                        self.adUnitsList = self.searchAdUnitsList.slice(0, AD_UNITS_LIMIT);
                        self.checkingCriteria();
                        _.each(self.searchAdUnitsList, function (adunit) {
                            if (adunit.criteria_link == 'included') {
                                self.setChlidDataCreteriaInclude(adunit);
                            } else if (adunit.criteria_link == 'excluded') {
                                self.setChlidDataCreteriaExclude(adunit);
                            } else {
                                self.setChlidDataDefaultCreteria(adunit);
                            }
                        })
                    }
                })
            } else if (event.keyCode == 8 && self.adUnitsSearch.length == 0) {
                self.searchAdUnitsList = [];
                self.adUnitsList = [];
                self.adUnitsList = angular.copy(self.previousAdunitsList);
                self.checkingCriteria();
            }
        }

        /*
        * load more ad units
        */
        self.loadMore = function () {
            document.getElementById("loadMore")
                .addEventListener('scroll', function (event) {
                    if ((event.target.offsetHeight + event.target.scrollTop + 20) > event.target.scrollHeight) {
                        if (self.adUnitsSearch && self.adUnitsSearch.length > 0) {
                            var loadAdUnitsObj = self.searchAdUnitsList.slice(self.adUnitsList.length, self.adUnitsList.length + AD_UNITS_LIMIT);
                            self.adUnitsList = self.adUnitsList.concat(loadAdUnitsObj);
                        } else {
                            var loadAdUnitsObj = self.setOfAdUnitsList.slice(self.adUnitsList.length, self.adUnitsList.length + AD_UNITS_LIMIT);
                            self.adUnitsList = self.adUnitsList.concat(loadAdUnitsObj);
                        }
                        $scope.$apply();
                    }
                });
        }

        self.checkChildCriteria = function (adunit) {
            for (var k = 0; k < self.selectedAdUnits.length; k++) {
                for (var j = 0; j < adunit.childData.length; j++) {
                    if (self.selectedAdUnits[k].name == adunit.childData[j].name) {
                        if (self.selectedAdUnits[k].criteria == "include") {
                            adunit.childData[j].criteria = 'include';
                            adunit.childData[j].criteria_link = 'included';
                        } else if (self.selectedAdUnits[k].criteria == "exclude") {
                            adunit.childData[j].criteria = 'exclude';
                            adunit.childData[j].criteria_link = 'excluded';
                        } else {
                            adunit.childData[j].criteria = '';
                            adunit.childData[j].criteria_link = 'include';
                        }
                    }
                }
            }
        }

        self.getChildAdUnits = function (item, isExpanded, type) {
            var selectedCretiriaList = [];
            if (isExpanded && type == 'parent' && self.searchAdUnitsList.length == 0) {
                ProductService.getAdunitsByContentKey({ type: 'dfp_ad_unit', value_id: item.valueId, cluster_id: self.clusterId }).then(function (success) {
                    if (success && success.data && success.data.length > 0) {
                        _.each(success.data, function (content) {
                            if (content.hasChildren) {
                                self.childData = [];
                                var slectedID = content.valueId;
                                content.childData = _.toArray(content.childData);
                                _.each(content.childData, function (item) {
                                    item.criteria = "";
                                    item.criteria_link = "include";
                                    self.childData.push(item);
                                })
                                self.setChlidDataDefaultCreteria(content);
                            }
                        })
                        _.each(self.adUnitsList, function (adunit) {
                            if (adunit.valueId == success.data[0].valueId && success.data[0].hasChildren) {
                                adunit.childData = self.childData;
                                if (adunit.criteria_link == 'included') {
                                    self.setChlidDataCreteriaInclude(adunit);
                                } else if (adunit.criteria_link == 'excluded') {
                                    self.setChlidDataCreteriaExclude(adunit);
                                } else {
                                    self.setChlidDataDefaultCreteria(adunit);
                                }
                                self.checkChildCriteria(adunit);
                            }
                        })
                    }
                }, function (error) { });
            } else if (isExpanded && item.hasChildren) {
                item.childData = _.toArray(item.childData);
                var selectedParent;
                if(self.searchAdUnitsList.length > 0){
                    selectedParent = _.find(self.searchAdUnitsList, function (el) { return el.valueId == item.superParentId });
                }else{
                    selectedParent = _.find(self.adUnitsList, function (el) { return el.valueId == item.superParentId });
                }
                if(item.showExclude || item.showInclude){
                    if(selectedParent.criteria_link == 'included' || selectedParent.criteria_link == 'excluded'){
                        selectedCretiriaList.push(selectedParent.criteria_link);
                    }
                    if (item.criteria_link == 'included') {
                        self.setChlidDataCreteriaInclude(item);
                    } else if (item.criteria_link == 'excluded') {
                        self.setChlidDataCreteriaExclude(item);
                    } else {
                        if (selectedParent.childData && selectedParent.childData.length > 0) {
                            self.applyCriteria(selectedParent.childData, item, selectedCretiriaList);
                        }
                     }
                }
                self.checkChildCriteria(item);
            }
        }

        self.applyCriteria = function (childNodesList, item, selectedCretiriaList) {
            childNodesList.every(function (element) {
                if (element.criteria_link == 'included' || element.criteria_link == 'excluded') {
                    selectedCretiriaList.push(element.criteria_link)
                } else {
                    if (element.hasChildren && element.childData.length > 0 && element.name !== item.name) {
                        self.applyCriteria(element.childData, item, selectedCretiriaList);
                    }
                }
            });
            if (selectedCretiriaList.length > 0) {
                if (selectedCretiriaList[0] == 'included') {
                    self.setChlidDataCreteriaInclude(item);
                } else if (selectedCretiriaList[0] == 'excluded') {
                    self.setChlidDataCreteriaExclude(item);
                }
            } else {
                self.setChlidDataDefaultCreteria(item);
            }
        }

        self.getAdUnitsByContentKey = function () {
            ProductService.getAdunitsByContentKey({ type: 'dfp_ad_unit', cluster_id: self.clusterId }).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var adUnit = {};
                        adUnit.valueId = content.valueId;
                        adUnit.name = content.name;
                        adUnit.criteria = "";
                        adUnit.criteria_link = "include";
                        adUnit.hasChildren = content.hasChildren;
                        self.setOfAdUnitsList.push(adUnit);
                    })
                    self.adUnitsList = self.setOfAdUnitsList.slice(0, AD_UNITS_LIMIT);
                    self.previousAdunitsList = angular.copy(self.adUnitsList);
                    self.loadMore();
                    if (self.editMode && self.selectedAdUnits && self.selectedAdUnits.length > 0) {
                        _.each(self.setOfAdUnitsList, function (category) {
                            _.each(self.selectedAdUnits, function (unit) {
                                if (unit.valueId == category.valueId) {
                                    category.criteria = unit.criteria;
                                    category.criteria_link = unit.criteria_link;
                                }
                            })
                        })
                        self.adUnitsIncluded = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'include'; });
                        self.adUnitsExcluded = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'exclude'; });
                    }
                }
            }, function (error) { });
        }

        self.initComponent = function () {
            if (self.selectedAdUnits || typeof self.selectedAdUnits === 'string') {
                self.selectedAdUnits = self.selectedAdUnits == "" ? [] : JSON.parse(self.selectedAdUnits);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getAdUnitsByContentKey();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                    self.adUnitsIncludedView = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'include'; });
                    self.adUnitsExcludedView = _.filter(self.selectedAdUnits, function (item) { return item.criteria == 'exclude'; });
                }
            } else {
                self.selectedAdUnits = [];
                self.enableViewMode = false;
                self.editMode = true;
                self.getAdUnitsByContentKey();
            }
        };

        self.initComponent();
    }
});